import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Acasă',
    href: '/'
  }, {
    name: 'Despre Mine',
    href: '/despremine'
  }, {
    name: 'Magazin',
    href: '/magazin'
  }, {
    name: 'Recenzii',
    href: '/testimoniale'
  }, {
    name: 'Resurse Gratuite',
    href: '/resursegratuite'
  }, {
    name: 'Contact',
    href: '/contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white ${isScrolled ? 'shadow-header' : ''}`} data-id="element-178">
      <div className="container-custom flex items-center justify-between h-[64px] md:h-[72px]" data-id="element-179">
        {/* Logo */}
        <Link to="/" className="flex items-center" data-id="element-180">
          <img src="https://cdn.magicpatterns.com/uploads/rVCUJtmK2CqH2rDkFmUSUs/LOGO.jpg" alt="Copilul tău" className="h-12 md:h-14 w-auto object-contain" data-id="element-181" />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-182">
          <ul className="flex items-center gap-6" data-id="element-183">
            {navLinks.map(link => <li key={link.name} data-id="element-184">
                <Link to={link.href} className="font-montserrat font-medium text-[14px] text-brand-text hover:text-brand-navy transition-colors relative group" data-id="element-185">
                  {link.name}
                  <span className="absolute -bottom-1 left-0 w-0 h-[2px] bg-brand-navy transition-all duration-300 group-hover:w-full" data-id="element-186"></span>
                </Link>
              </li>)}
          </ul>
          <Link to="/evaluarecadou" className="btn-primary !py-2 !px-6 !text-[14px]" data-id="element-187">
            Evaluare + Plan
          </Link>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-brand-navy p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-188">
          {isMobileMenuOpen ? <XIcon size={24} data-id="element-189" /> : <MenuIcon size={24} data-id="element-190" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-191">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-t border-gray-100 overflow-hidden" data-id="element-192">
            <div className="container-custom py-6 flex flex-col gap-6" data-id="element-193">
              <ul className="flex flex-col gap-4" data-id="element-194">
                {navLinks.map(link => <li key={link.name} data-id="element-195">
                    <Link to={link.href} className="font-montserrat font-medium text-[16px] text-brand-text block py-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-196">
                      {link.name}
                    </Link>
                  </li>)}
              </ul>
              <Link to="/evaluarecadou" className="btn-primary w-full text-center" onClick={() => setIsMobileMenuOpen(false)} data-id="element-197">
                Evaluare + Plan
              </Link>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}